
import { CAPTAIN_WORKFLOW_STAGE, getCaptainWorkflow } from '../../features/match/model/captainWorkflow';

const GameStep = ({ gameDetail, yearStatus }) => {
    if (gameDetail?.statusInfo !== 1) return null;

    if (Number(gameDetail?.gameType) === 4) {
        // 年会队伍已在建赛时分配，无需展示普通比赛的分队、调换、选队四步流程。
        const teams = [
            { name: gameDetail?.greenName || 'A 队', confirm: Number(gameDetail?.greenCaptainConfirm), external: Number(gameDetail?.greenTeamType) === 1, captain: gameDetail?.greenCaptain?.name },
            { name: gameDetail?.redName || 'B 队', confirm: Number(gameDetail?.redCaptainConfirm), external: Number(gameDetail?.redTeamType) === 1, captain: gameDetail?.redCaptain?.name }
        ];
        const pending = teams.filter(team => team.confirm !== 2 && !team.external);
        return <div className="annual-lineup-status">
            <div className="annual-lineup-title">首发阵容确认</div>
            {teams.map(team => <div className="annual-lineup-row" key={team.name}>
                <span className="annual-lineup-team">{team.name}</span>
                <span className={team.confirm === 2 ? 'annual-lineup-done' : 'annual-lineup-pending'}>
                    {team.confirm === 2 ? (team.external ? '门将自动确认' : '已确认') : (team.confirm === 1 ? '排阵中' : '待排阵')}
                </span>
            </div>)}
            <div className="annual-lineup-hint">{pending.length === 0
                ? (yearStatus === 0 ? '阵容已确认，管理员可一键开始活动并开赛。' : yearStatus === 2 ? '活动已结束，无法开赛。' : '阵容已确认，管理员可以开始比赛。')
                : `等待 ${pending.map(team => team.captain || team.name).join('、')} 确认首发。`}</div>
        </div>;
    }

    const { stage, stepIndex, steps } = getCaptainWorkflow(gameDetail)
    const progressWidth = (stepIndex / (steps.length - 1)) * 100;
    const currentStep = steps[stepIndex];

    return (
        <div className="premium-steps-container">
            {/* 流程状态由 captainWorkflow 统一计算，组件只负责呈现步骤层级。 */}
            <div className="premium-steps-header">
                {/* 隐去标题和辅助说明，保留当前阶段状态提示。 */}
                <span className="premium-steps-stage">进行中 · {currentStep?.title}</span>
            </div>
            {/* 内讧赛按命名、调人、选队、排阵四步展示。 */}
            <div className="premium-steps-row">
                <div className="premium-steps-line">
                    <div
                        className="premium-steps-line-progress"
                        style={{ width: `${progressWidth}%` }}
                    />
                </div>
                {steps.map((step, index) => {
                    let statusClass = "";
                    if (index < stepIndex) statusClass = "completed";
                    else if (index === stepIndex) statusClass = "active";
                    else statusClass = "pending";

                    return (
                        <div key={index} className={`premium-step-item ${statusClass}`}>
                            <div className="premium-step-node">
                                {index < stepIndex ? "✓" : step.icon}
                            </div>
                            <div className="premium-step-text-group">
                                <div className="premium-step-title">{step.title}</div>
                                <div className="premium-step-description">{step.description}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="premium-steps-hint">
                {stage === CAPTAIN_WORKFLOW_STAGE.READY_TO_START
                    ? '双方阵容已确认，管理员可以开始比赛'
                    : <>当前由 <strong>{currentStep?.title}</strong> 负责：{currentStep?.description}；完成后进入下一步</>}
            </div>
        </div>
    );
};

export default GameStep;
